import { useSetAdminOrganizationStatusMutation } from "@/redux/services/adminOrganizationsApi"
import { useAppDispatch } from "@/redux/hooks"
import { setToast } from "@/redux/toastSlice"
import { getErrorMessage } from "@/core/api/helpers"
import type { SetOrganizationStatus } from "@/types/entities/organization"

export const useAdminSetOrganizationStatus = (onSuccess?: () => void) => {
  const dispatch = useAppDispatch()
  const [setAdminOrganizationStatus, response] =
    useSetAdminOrganizationStatusMutation()

  const handleAdminSetOrganizationStatus = async ({
    status,
    id,
  }: SetOrganizationStatus & { id: string }) => {
    try {
      const response = await setAdminOrganizationStatus({
        body: { status },
        id,
      }).unwrap()
      typeof onSuccess === "function" && onSuccess()
      dispatch(
        setToast({
          show: true,
          variant: "success",
          message: `Success ${
            status === "disabled" ? "disable" : "enable"
          } organization`,
        }),
      )
      return response
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
    }
  }

  return {
    setAdminOrganizationStatus: handleAdminSetOrganizationStatus,
    response,
  }
}
